import { ChartDataSets, ChartOptions, ChartPluginsOptions, ChartType } from 'chart.js';
import { Label, Color } from 'ng2-charts';

/**
 * Import moment.js in order to translate date labels correclty
 */
import moment from 'moment';
import { DsChartInterface } from '../interfaces/ds-chart.interface';
import { DS_CHARTS_DEFAULT_OPTIONS } from '../constants/ds-charts-default-options.constant';
import { DsChartCustomOptions } from '../interfaces/ds-chart-custom-options.interface';
import { getLegend } from '../functions/ds-charts.functions';

export class DsChart {
  /**
   * Array of chart datasets.
   */
  public datasets: ChartDataSets[] = [];

  /**
   * Labels displayed on the X axis.
   */
  public labels: Label[] = [];

  /**
   * Options for the chart. Same options as chart.js
   */
  public options: ChartOptions = {};

  /**
   * Colors of datasets in order.
   */
  public colors: Color[] = [];

  /**
   * Whether to display the chart legend
   */
  public legend: boolean;

  /**
   * List of plugin names. Left empty by default.
   */
  public plugins: ChartPluginsOptions = [];

  /**
   * Chart type
   */
  public chartType: ChartType;

  /**
   * Moment instance.
   */
  moment: moment.Moment;

  /**
   * Creates an instance of DsChart.
   *
   * @param language current language
   */
  constructor(language = 'en') {
    //   Set moment locale to translate dates properly
    moment.locale(language);
    this.moment = moment();
  }

  /**
   * Initialize chart.
   *
   * @param chart the DsChart data
   */
  public initChart(chart: DsChartInterface) {
    this.datasets = chart.datasets;
    this.labels = chart.labels;
    this.options = chart.options;
    this.colors = chart.colors;
    this.legend = chart.legend;
    this.chartType = chart.chartType || this.chartType;
  }

  /**
   * Returns a chart options object containing the default values, and other values that could be merged automatically.
   *
   * @param customOptions Custom chart options
   * @returns ChartOptions
   */
  protected getMergedOptions(customOptions: DsChartCustomOptions = {}): ChartOptions {
    const options: ChartOptions = this.getOptions(DS_CHARTS_DEFAULT_OPTIONS);
    options.legend = getLegend(customOptions);
    options.tooltips = { ...options.tooltips, ...customOptions.tooltips };
    return options;
  }

  /**
   * Get chart options without modifying given object.
   *
   * @param chartOptions the chart options
   * @returns ChartOptions
   */
  private getOptions(chartOptions: ChartOptions): ChartOptions {
    return JSON.parse(JSON.stringify(chartOptions)) as ChartOptions;
  }
}
